<template>
  <spinner v-if="loading" />
  <div v-else class="screen-container">
    <v-flex v-if="!event.extraModules.floorPlan" class="mb-16 mobile-button mobile-buttons hide">
      <main-button
        depressed
        :disabled="!user.isVerifiedByCoreEvent"
        text="Create Ticket"
        @click="onCreateTicketClick"
      />
    </v-flex>
    <v-flex v-else class="mb-16 mobile-button mobile-buttons hide">
      <v-menu v-model="ticketMenu" offset-y nudge-bottom="4">
        <main-button slot="activator" style="padding: 10px 20px">
          <v-icon class="material-icons" color="white"> add</v-icon>
          <span style="color: white; margin: 0 12px"> New ticket </span>
          <v-icon class="material-icons" color="white"> expand_more</v-icon>
        </main-button>
        <v-list
          v-for="(item, index) in ticketTypeData"
          :key="index"
          style="padding: 0"
          class="menu-mobile"
        >
          <div class="ticket-container" @click="onCreateTicketFloorPlanClick(item)">
            <img :src="require(`../../../public/assets/${item.svg}`)" :alt="item.svg" />
            <span class="ticket-type">{{ item.type }}</span>
          </div>
        </v-list>
      </v-menu>
    </v-flex>
    <v-flex class="mb-16 mobile-button mobile-buttons hide">
      <main-button
        outline
        class="gratis-mobile-button"
        text="Gratis Ticket"
        @click="onCreateGratisTicketClick"
      />
    </v-flex>
    <v-layout column>
      <v-flex class="title-screen" xs12>
        <span>Tickets</span>
      </v-flex>
      <v-flex x4>
        <div class="title-description attendee-table-description" />
      </v-flex>
      <v-flex class="mb-16 desktop-button">
        <v-toolbar-items v-if="event.extraModules.floorPlan">
          <v-menu v-model="ticketMenu" offset-y nudge-bottom="4">
            <main-button slot="activator" style="padding: 10px 20px">
              <v-icon class="material-icons" color="white"> add</v-icon>
              <span style="color: white; margin: 0 12px"> New ticket </span>
              <v-icon class="material-icons" color="white"> expand_more</v-icon>
            </main-button>
            <v-list
              v-for="(item, index) in ticketTypeData"
              :key="index"
              style="padding: 0"
              class="menu"
            >
              <div class="ticket-container" @click="onCreateTicketFloorPlanClick(item)">
                <img :src="require(`../../../public/assets/${item.svg}`)" :alt="item.svg" />
                <span class="ticket-type">{{ item.type }}</span>
              </div>
            </v-list>
          </v-menu>
          <main-button outline class="gratis-button" @click="onCreateGratisTicketClick()">
            <img class="gratis-ticket-icon" src="/assets/free-ticket.svg" alt="Gratis Ticket" />
            Gratis Ticket
          </main-button>
        </v-toolbar-items>
        <div v-else>
          <main-button depressed @click="onCreateTicketClick">
            <span class="add-symbol">+</span>Create ticket
          </main-button>
          <main-button outline @click="onCreateGratisTicketClick()">
            <img class="gratis-ticket-icon" src="/assets/free-ticket.svg" alt="Gratis Ticket" />
            Gratis Ticket
          </main-button>
          <main-button
            text="Event's max capacity"
            flat
            class="max-capacity-button"
            @click="isEventMaxCapacityModalOpen = !isEventMaxCapacityModalOpen"
          />
        </div>
      </v-flex>
      <div v-if="!$apollo.loading" class="attendee_table">
        <selected-items-header
          v-if="selected.length"
          :selected="selected"
          name="ticket"
          @clear="selected = []"
          @delete="showDeleteDialog = true"
        />
        <div
          v-if="tickets.length === 0"
          class="no-attendees-message-container border__left border__right"
        >
          <span class="no-attendees-message">No matching records found.</span>
        </div>
        <table-list
          v-else
          :hide-checkbox="true"
          :show-toggle-button="true"
          :event-id="eventId"
          :organization-slug="organizationSlug"
          :selected.sync="selected"
          :attendees="tickets"
          body-style="grid-auto-columns: 128px minmax(150px, 372px) !important;"
          :visible-fields="visibleFields"
          :attendee-fields="attendeeFields"
          :pagination="pagination"
          @click="
            goTo(
              isRegularOrganization()
                ? routes.organizer.editTicket
                : routes.sportOrganizer.editTicketSport,
              { eventId: eventId, ticketId: $event },
            )
          "
          @sort="handleSort($event)"
          @orderDelete="
            ;(ticketDeleteId = $event),
              (ticketDeleteExists = true),
              canBeDeletedHandler(ticketDeleteId)
          "
          @updateTicketActivity="updateTicketActivity"
        />
        <table-pagination
          :pagination="pagination"
          :total-attendees="totalTicketCount"
          @change="handlePagination($event)"
          @changePerPage="handlePagination($event)"
        />
      </div>
    </v-layout>
    <delete-dialog
      :content="`Are you sure you want to delete selected tickets? This operation cannot be undone.`"
      :on-delete="deleteSelected"
      :show.sync="showDeleteDialog"
      title="Delete tickets"
    />
    <div v-if="ticketDeleteExists && ticketCanBeDeleted" class="delete-wrapper">
      <div class="delete-container">
        <div class="delete-header">
          <h1 class="delete-title">Are you sure you want to delete this ticket type?</h1>
          <img
            alt="Close window"
            src="/assets/close-icon.svg"
            class="close-icon-style"
            @click="ticketDeleteExists = !ticketDeleteExists"
          />
        </div>
        <p class="delete-description">
          Users will not be able to see or buy this ticket type and all the data will be lost. If
          you just want to hide this ticket type, you can change the visibility setting in the edit
          section. If you still want to proceed, this action cannot be undone.
        </p>
        <div class="delete-buttons">
          <main-button
            text="Edit ticket"
            outline
            @click="
              goTo(
                isRegularOrganization()
                  ? routes.organizer.editTicket
                  : routes.sportOrganizer.editTicketSport,
                { eventId: eventId, ticketId: ticketDeleteId },
              )
            "
          />
          <main-button
            text="Delete"
            color="#DB384C"
            @click="deleteTicket(), (ticketDeleteExists = !ticketDeleteExists)"
          />
        </div>
      </div>
    </div>
    <div v-if="event.extraModules.floorPlan" class="ticket-sales-channels">
      <p v-if="!tickets.length" class="tisak-term">
        Create at least one ticket before selecting sales channel.
      </p>
      <div class="sellers-input">
        <select-field
          v-model="selectedSalesChannel"
          :disabled="!!!tickets.length"
          :items="salesChannels"
          label="Sales Channel"
          class="sales-channels"
        />
        <v-select
          v-if="selectedSalesChannel === SalesChannels.SPECIFIC_OUTLETS"
          v-model="form.sellers"
          class="select-outlets"
          :items="availableSellers"
          :menu-props="{ offsetY: true }"
          item-value="id"
          item-text="name"
          label="Select Outlets"
          multiple
          chips
          hide-selected
        >
          <template v-slot:selection="{ item }">
            <v-chip color="white" text-color="#0277BD" close @input="deselectSeller(item)">
              {{ item.name }}
            </v-chip>
          </template>
        </v-select>
      </div>
    </div>
    <p
      v-if="
        (form.sellers.length && tisak && form.sellers.includes(tisak.id)) ||
        selectedSalesChannel === SalesChannels.ALL_OUTLETS
      "
      class="tisak-term"
    >
      TISAK outlets will charge ticket buyers additional 1 EUR per ticket
    </p>
    <main-button
      v-if="event.extraModules.floorPlan"
      :disabled="!canUpdateSaleChannel"
      text="Save sales channels"
      @click="updateSalesChannels()"
    />
    <div v-if="ticketDeleteExists && !ticketCanBeDeleted" class="delete-wrapper">
      <div class="delete-container">
        <div class="delete-header">
          <h1 class="delete-title">This ticket type cannot be deleted</h1>
          <img
            alt="Close window"
            src="/assets/close-icon.svg"
            class="close-icon-style"
            @click="ticketDeleteExists = !ticketDeleteExists"
          />
        </div>
        <p class="delete-description">
          There are purchases containing this ticket type. If you want users to not be able to see
          or buy this ticket type, you can change the visibility setting in the edit section.
        </p>
        <div class="delete-buttons">
          <main-button
            depressed
            text="Edit ticket"
            @click="
              goTo(
                isRegularOrganization()
                  ? routes.organizer.editTicket
                  : routes.sportOrganizer.editTicketSport,
                { eventId: eventId, ticketId: ticketDeleteId },
              )
            "
          />
        </div>
      </div>
    </div>
    <simple-snackbar
      :open.sync="snackbarOpen"
      message-prop="Sales channels save successfully."
      color="primary"
    />
    <simple-snackbar v-bind.sync="maxTicketsErrorSnackBar" />
    <simple-snackbar v-bind.sync="salesStatusSnackbar" />
    <event-max-capacity-modal
      v-if="isEventMaxCapacityModalOpen"
      :audience-capacity="event.audienceCapacity"
      @close="isEventMaxCapacityModalOpen = false"
      @updateMaxCapacity="updateMaxCapacity"
    />
    <demo-modal v-if="demoModal" :user="user" @close="demoModal = false" />
  </div>
</template>

<script>
import EventMaxCapacityModal from '@/components/tickets/event-max-capacity-modal.vue'
import { GET_EVENT_DETAILS, SET_MAX_TICKETS_NUMBER } from '@/graphql/event.graphql'
import {
  CHANGE_TICKET_VALIDITY_DATES,
  DELETE_ORDER_ITEM,
  DELETE_ORDER_ITEMS,
  GET_ORDER_ITEMS,
  UPDATE_SALES_CHANNELS,
} from '@/graphql/orderItem.graphql'
import { GET_TICKET_SELLERS } from '@/graphql/user.graphql'
import { SalesChannels, TicketSellerOrganizationType, OrganizationType } from '@/types'
import { tisakTicketSeller } from '@/utils'
import TableList from '../accreditations/attendee-table/list.vue'
import TablePagination from '../accreditations/attendee-table/pagination.vue'
import SimpleSnackbar from '../shared/snackbars/simple-snackbar.vue'
import DeleteDialog from './../shared/dialogs/delete-dialog.vue'
import SelectedItemsHeader from './selected-items-header'
import DemoModal from '@/components/organizations/DemoModal.vue'

export default {
  name: 'tickets-list',
  components: {
    DemoModal,
    EventMaxCapacityModal,
    TableList,
    TablePagination,
    SelectedItemsHeader,
    DeleteDialog,
    SimpleSnackbar,
  },
  props: {
    eventId: String,
    user: Object,
    organizationSlug: String,
  },
  data() {
    const { pagination } = this.getInitialFromQueryParams()

    return {
      attendees: [],
      totalTicketCount: 0,
      categories: [],
      attendeeFields: {},
      snackbarOpen: false,
      demoModal: false,
      visibleFields: [
        'Ticket name',
        'Ticket category',
        'Quantity',
        'Price',
        'Start date',
        'End date',
        // 'Sales channel',
      ],
      ticketTypeData: [
        {
          type: 'STANDING TICKET',
          svg: 'Stand.svg',
          linkParams: function () {
            return this.handleOpenTicketModal('parter', true)
          }.bind(this),
        },
        {
          type: 'SEATING TICKET',
          svg: 'Seat.svg',
          linkParams: function () {
            return this.handleOpenTicketModal()
          }.bind(this),
        },
        {
          type: 'TABLE TICKET',
          svg: 'Table.svg',
          linkParams: function () {
            return this.handleOpenTicketModal('table', false, true)
          }.bind(this),
        },
      ],
      eventAttendeeFields: {},
      selected: [],
      pagination,
      tisak: {},
      SalesChannels,
      form: { sellers: [] },
      ticketMenu: false,
      initialSalesChannels: SalesChannels.ONLINE,
      salesChannels: Object.values(SalesChannels),
      selectedSalesChannel: SalesChannels.ONLINE,
      availableSellers: [],
      snackbar: false,
      showDeleteDialog: false,
      event: { extraModules: { floorPlan: false } },
      paginationLoading: false,
      tickets: [],
      loading: true,
      ticketDeleteId: 0,
      ticketDeleteExists: false,
      ticketCanBeDeleted: false,
      isEventMaxCapacityModalOpen: false,
      maxTicketsErrorSnackBar: {},
      salesStatusSnackbar: {},
    }
  },
  apollo: {
    getEventBySlug: {
      query: GET_EVENT_DETAILS,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      manual: true,
      async result({ loading, data }) {
        if (!loading) {
          const { getEvent: event } = data
          this.event = event
          if (event.venueId) {
            this.visibleFields.splice(1, 0, 'Type')
          }
          this.filterSportPrepaidCouponTickets()
        }
      },
    },
    getOrderItems: {
      query: GET_ORDER_ITEMS,
      variables() {
        return {
          eventId: this.eventId,
          status: 'ALLOWED',
          pagination: this.pagination,
        }
      },
      manual: true,
      async result({ data, loading }) {
        if (!loading) {
          const {
            data: { getTicketSellers },
          } = await this.$apollo.query({ query: GET_TICKET_SELLERS })
          const allTicketSellers = getTicketSellers.filter(
            ts => ts.type !== TicketSellerOrganizationType.THEATER,
          )
          this.availableSellers = allTicketSellers
          this.tisak = allTicketSellers.find(u => u.name.toLowerCase() === tisakTicketSeller)
          this.tickets = this.mapTickets(data.getOrderItems.items)
          this.setVisibleFields(data)
          this.totalTicketCount = data.getOrderItems.totalCount
          this.loading = false
          this.filterSportPrepaidCouponTickets()
        }
      },
    },
  },
  computed: {
    canUpdateSaleChannel() {
      const atLeastOneTicket = !!this.tickets.length
      const channelChangedAndHasSelectedSellers =
        this.selectedSalesChannel === this.SalesChannels.SPECIFIC_OUTLETS &&
        this.form.sellers.length === 0

      return atLeastOneTicket && !channelChangedAndHasSelectedSellers
    },
  },
  methods: {
    setVisibleFields(data) {
      if (
        data.getOrderItems.items.length &&
        data.getOrderItems.items[0].event.extraModules.floorPlan
      ) {
        this.visibleFields = this.visibleFields.filter(field => field !== 'Quantity')
      }

      if (
        data.getOrderItems.items.length &&
        !data.getOrderItems.items[0].event.extraModules.floorPlan
      ) {
        this.visibleFields.push('W/ access code')
      }
    },
    mapTickets(tickets) {
      return tickets.map(ticket => {
        let type = null
        if (ticket.itemMeta.table) {
          type = 'Table'
        } else if (ticket.itemMeta.parter) {
          type = 'Parter'
        } else {
          type = 'Seat'
        }
        const fromDate = new Date(ticket.from)
        const toDate = new Date(ticket.to)

        const yeFrom = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(fromDate)
        const moFrom = new Intl.DateTimeFormat('en', { month: 'numeric' }).format(fromDate)
        const daFrom = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(fromDate)

        const yeTo = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(toDate)
        const moTo = new Intl.DateTimeFormat('en', { month: 'numeric' }).format(toDate)
        const daTo = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(toDate)

        let ticketSellersLabel = ''
        if (ticket.ticketSellerOrganizations.length === 0) {
          ticketSellersLabel = this.SalesChannels.ONLINE
        } else if (ticket.ticketSellerOrganizations.length < this.availableSellers.length) {
          ticketSellersLabel = _.first(ticket.ticketSellerOrganizations.map(s => s.name))
          this.form.sellers = ticket.ticketSellerOrganizations.map(s => s.id)
          this.selectedSalesChannel = this.SalesChannels.SPECIFIC_OUTLETS
          this.initialSalesChannels = this.SalesChannels.SPECIFIC_OUTLETS
          this.salesChannels = this.salesChannels.filter(
            channel => channel !== this.SalesChannels.ONLINE,
          )
        } else if (ticket.ticketSellerOrganizations.length === this.availableSellers.length) {
          this.form.sellers = this.availableSellers.map(s => s.id)
          ticketSellersLabel = this.SalesChannels.ALL_OUTLETS
          this.selectedSalesChannel = this.SalesChannels.ALL_OUTLETS
          this.initialSalesChannels = this.SalesChannels.ALL_OUTLETS
          this.salesChannels = this.salesChannels.filter(
            channel => channel !== this.SalesChannels.ONLINE,
          )
        } else {
          ticketSellersLabel = `${ticket.ticketSellerOrganizations.length} outlets`
        }

        return {
          ...ticket,
          ticketSellersLabel,
          isSoldOut: ticket.quantity == ticket.initialQuantity,
          quantity: `${ticket.quantity}`,
          from: `${daFrom}.${moFrom}.${yeFrom}`,
          to: `${daTo}.${moTo}.${yeTo}`,
          type,
          fullDateFrom: ticket.from,
          fullDateTo: ticket.to,
          accessCode:
            ticket.itemMeta && ticket.itemMeta.accessCode ? ticket.itemMeta.accessCode : '',
        }
      })
    },
    handleOpenTicketModal(type = 'regular') {
      this.goTo(
        this.isRegularOrganization()
          ? this.routes.organizer.createTicket
          : this.routes.sportOrganizer.createTicketSport,
        {
          eventId: this.eventId,
          user: this.user,
          type,
        },
      )
    },
    handleOpenGratisTicketModal() {
      this.goTo(
        this.isRegularOrganization()
          ? this.routes.organizer.createGratisTicket
          : this.routes.sportOrganizer.createGratisTicketSport,
        {
          eventId: this.eventId,
          user: this.user,
          organizationSlug: this.organizationSlug,
        },
      )
    },
    async updateSalesChannels() {
      let salesChannels = []
      let changeInitialSalesChannels = this.SalesChannels.ONLINE
      if (this.selectedSalesChannel === this.SalesChannels.SPECIFIC_OUTLETS) {
        salesChannels = this.form.sellers
        changeInitialSalesChannels = this.SalesChannels.SPECIFIC_OUTLETS
      } else if (this.selectedSalesChannel === this.SalesChannels.ALL_OUTLETS) {
        changeInitialSalesChannels = this.SalesChannels.ALL_OUTLETS
        salesChannels = this.availableSellers.map(seller => seller.id)
      }

      const { data, error } = await this.$apollo.mutate({
        mutation: UPDATE_SALES_CHANNELS,
        variables: {
          eventId: this.eventId,
          salesChannels: salesChannels,
        },
      })
      if (!error) {
        this.initialSalesChannels = changeInitialSalesChannels
        this.snackbarOpen = true
        if (this.initialSalesChannels === this.SalesChannels.ONLINE) {
          this.form.sellers = []
        }
      }
      await this.$apollo.queries.getOrderItems.refetch()
    },
    deselectSeller(item) {
      this.form.sellers = this.form.sellers.filter(sellerId => sellerId !== item.id)
    },
    canBeDeletedHandler(ticketId) {
      const ticket = this.tickets.find(t => t.id == ticketId)
      this.ticketCanBeDeleted = ticket.isSoldOut

      return
    },
    async handlePagination({ page, per_page }) {
      const { page: currentPage, per_page: currentPerPage } = this.pagination
      if (currentPage > page && currentPage === 1) return
      if (page > currentPage && !(this.totalTicketCount - currentPerPage * currentPage > 0)) return

      this.pagination = {
        ...this.pagination,
        per_page: per_page === 'All' ? -1 : per_page,
        page: page,
      }

      this.addPaginationToRoute(this.pagination)

      await this.$apollo.queries.getOrderItems.refetch()
    },
    async handleSort(sortBy) {
      const { per_page, page, sortBy: thisSortBy, descending } = this.pagination
      const pagination = {
        page,
        per_page,
        sortBy,
        descending: sortBy === thisSortBy ? !descending : false,
      }
      this.addPaginationToRoute(pagination)
      this.pagination = pagination
    },
    getInitialFromQueryParams() {
      const { per_page, page, sortBy, descending } = this.$route.query

      return {
        pagination: {
          page: parseInt(page, 10) || 1,
          per_page: parseInt(per_page, 10) || 25,
          sortBy: sortBy,
          descending: descending === 'true' ? true : false,
        },
      }
    },
    addPaginationToRoute({ page, per_page, sortBy, descending }) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          per_page,
          page,
          sortBy,
          descending,
        },
      })
    },
    async deleteTicket() {
      await this.$apollo.mutate({
        mutation: DELETE_ORDER_ITEM,
        variables: {
          orderItemId: this.ticketDeleteId,
        },
      })

      await this.$apollo.queries.getOrderItems.refetch()
    },
    async deleteSelected() {
      await this.$apollo.mutate({
        mutation: DELETE_ORDER_ITEMS,
        variables: {
          orderItemIds: this.selected,
        },
      })

      this.selected = []
      await this.$apollo.queries.getOrderItems.refetch()
    },
    async updateTicketActivity(ticketId, validity) {
      const { errors } = await this.$apollo.mutate({
        mutation: CHANGE_TICKET_VALIDITY_DATES,
        variables: { organizationSlug: this.organizationSlug, orderItemId: ticketId, validity },
      })

      if (errors) {
        this.salesStatusSnackbar = {
          open: true,
          messageProp: errors[0].message,
          color: 'error',
        }

        return
      }

      await this.$apollo.queries.getOrderItems.refetch()
    },
    async updateMaxCapacity(maxCapacityValue) {
      const { errors } = await this.$apollo.mutate({
        mutation: SET_MAX_TICKETS_NUMBER,
        variables: {
          eventId: this.eventId,
          maxTickets: maxCapacityValue === null ? null : Number(maxCapacityValue),
        },
      })

      if (errors) {
        this.maxTicketsErrorSnackBar = {
          open: true,
          messageProp: errors[0].message,
          color: 'error',
        }

        return
      }

      this.isEventMaxCapacityModalOpen = false
      this.maxTicketsErrorSnackBar = {
        open: true,
        messageProp: "Event's max capacity successfully updated.",
        color: 'primary',
      }
      await this.$apollo.queries.getEventBySlug.refetch()
    },

    isRegularOrganization() {
      return this.$route.path.includes('/organizations/')
    },

    filterSportPrepaidCouponTickets() {
      if (
        !this.event.organization ||
        this.loading ||
        this.event.organization.type !== OrganizationType.SPORT_ORGANIZATION
      )
        return

      this.tickets = this.tickets.filter(ticket => !ticket.prepaidCoupon)
    },
    onCreateGratisTicketClick() {
      if (!this.user.isVerifiedByCoreEvent) {
        this.demoModal = true
      } else {
        this.handleOpenGratisTicketModal()
      }
    },
    onCreateTicketClick() {
      if (!this.user.isVerifiedByCoreEvent) {
        this.demoModal = true
      } else {
        this.goTo(
          this.isRegularOrganization()
            ? this.routes.organizer.createTicket
            : this.routes.sportOrganizer.createTicketSport,
          { eventId: this.eventId, user: this.user },
        )
      }
    },
    onCreateTicketFloorPlanClick(item) {
      if (!this.user.isVerifiedByCoreEvent) {
        this.demoModal = true
      } else {
        return item.linkParams()
      }
    },
  },
}
</script>

<style scoped>
.attendee-table-description {
  max-width: 900px;
  margin-bottom: 28px;
}

.no-attendees-message-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-attendees-message {
  color: #979797;
  padding: 20px;
}

.border__left {
  border-left: 2px solid #f5f5f5;
}

.border__right {
  border-right: 2px solid #f5f5f5;
}

ul {
  list-style-type: none;
}

.err-line {
  margin-bottom: 8px;
}

.sellers-input {
  display: flex;
  column-gap: 1.5rem;
}

.err-line span {
  font-weight: bold;
}

.title-screen {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}

.gratis-ticket-icon {
  margin-right: 0.5rem;
}

.gratis-mobile-button {
  margin-top: 3.5rem;
}

.gratis-button {
  margin-left: 1rem !important;
  height: 3rem;
  padding: 0.625rem 1.25rem;
}

.menu-mobile {
  display: none !important;
}

@media screen and (max-width: 800px) {
  .menu {
    display: none !important;
  }

  .menu-mobile {
    display: block !important;
  }

  .gratis-mobile-button {
    background-color: white !important;
  }

  .title-screen {
    display: none;
  }

  .screen-container {
    margin-top: 1.5rem;
  }
}

.add-symbol {
  font-size: 1.875rem;
  margin-right: 0.8125rem;
  font-weight: 200;
}

.delete-message {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: white;
  opacity: 80%;
  z-index: 500;
}

.delete-wrapper {
  background-color: rgba(0, 0, 0, 0.8);
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  content: '';
  position: fixed;
}

.delete-wrapper > .delete-container {
  width: 43.75rem;
  background: white;
  position: fixed;
  max-width: 80%;
  opacity: none;
  text-align: left;
  border-radius: 0.5rem;
  top: 25%;
  left: 50%;
  filter: drop-shadow(0px 0px 24px rgba(51, 51, 51, 0.2));
  padding: 1.25rem;
  transform: translate(-50%, 0);
}

.delete-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  letter-spacing: -0.03em;
  color: #0277bd;
  margin-bottom: 1.5rem;
}

.delete-description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #666666;
}

.delete-buttons {
  display: flex;
  justify-content: flex-end;
}

.ticket-container {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
}

.ticket-container:hover {
  background: #cee4f2;
}

.delete-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.close-icon-style:hover {
  cursor: pointer;
}

.ticket-sales-channels {
  margin-top: 2rem !important;
  display: flex;
  flex-direction: column;
}

.ticket-type {
  color: var(--Primary-10, #0277bd);
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'clig' off, 'liga' off;
  /* Button/Large */
  font-family: Raleway;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 21.6px */
  letter-spacing: -0.27px;
  text-transform: uppercase;
}

.sales-channels {
  width: 330px;
}

@media screen and (max-width: 1175px) {
  .ticket-sales-channels {
    display: flex;
    flex-direction: column;
  }

  .sales-channels {
    width: 50%;
  }

  .select-outlets {
    width: 50%;
  }
}

.max-capacity-button {
  float: right;
}
</style>
